import { useEffect, useState } from "react";
import { calculateDashboardData } from "~/features/dashboard/utils";
import type { DashboardState } from "~/features/dashboard/types";
import { defaultMetrics } from "~/features/dashboard/types";
import { QuickActions } from "~/features/dashboard/components/QuickActions";
import { ActiveBlocks } from "~/features/dashboard/components/ActiveBlocks";

export default function Overview() {
  const [state, setState] = useState<DashboardState>(() => {
    // Initialize with calculated data
    if (typeof window !== "undefined") {
      return calculateDashboardData();
    }
    return {
      metrics: defaultMetrics,
      nextOrders: [],
      transferQueue: [],
      callbacks: [],
      navOutbox: [],
      blocks: [],
    };
  });

  useEffect(() => {
    // Refresh data on mount
    const data = calculateDashboardData();
    setState(data);
  }, []);

  const { metrics, nextOrders, transferQueue, callbacks, navOutbox, blocks } = state;

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">📊 Dispatch Command Center</h1>
        <p className="page-subtitle">
          Track live calling, callbacks, and scheduled delivery readiness.
        </p>
      </div>

      <QuickActions />

      <ActiveBlocks blocks={blocks} />
    </div>
  );
}
